import React, { useState, useEffect } from "react";
import { getFirestore, collection, addDoc, doc, getDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import Menu from './Menu.js';
import MenuSuperior from "./MenuSuperior.js";
import Puestos from "./Puestos.js";
import Configuracion from "./Configuracion.js";
import SentRequests from './SentRequests.js';
import MensajesOP from './MensajesOP.js'; 
import CRM from './CRM.js';
import Loading from "./Loading.js";
const EmpresaOffice = () => {
  const db = getFirestore();
  const auth = getAuth();
  const [activeSection, setActiveSection] = useState("puestos");
  const [empresa, setEmpresa] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserRoleAndEmpresa = async () => {
      setLoading(true);
      const user = auth.currentUser;
      if (user) {
        try {
          // Verificar el rol del usuario
          const userDoc = await getDoc(doc(db, "users", user.uid));
          if (userDoc.exists() && userDoc.data().role === "empresa") {
            setRole("empresa");

            // Buscar la empresa asociada al usuario
            const empresaDoc = await getDoc(doc(db, "empresas", user.uid));
            if (empresaDoc.exists()) {
              setEmpresa(empresaDoc.data());
            } else {
              setActiveSection("configuracion");
            }
          } else {
            setRole(null);
          }
        } catch (error) {
          console.error("Error al obtener datos del usuario o empresa:", error);
        }
      }
      setLoading(false);
    };

    fetchUserRoleAndEmpresa();
  }, [db, auth]);


  // Si el usuario no tiene el rol "empresa", mostrar un mensaje
  if (role !== "empresa") {
    return <div>No tienes permiso para acceder a esta sección.</div>;
  }

  if (loading) {
    return <div><Loading /></div>;
  }

  return (
    <div className="vp-container">
    <div className="vp-main-content">
        <div className="empresa-office">
        <MenuSuperior setActiveSection={setActiveSection} />
        <div className="empresa-office__content">
            {activeSection === "puestos" && <Puestos />}
            {activeSection === 'requests' && <SentRequests />}
            {activeSection === 'crm' && <CRM />}
            {activeSection === "configuracion" && <Configuracion />}
            {activeSection === "mensajes" && <MensajesOP />}
        </div>
        </div>
    </div>
    <Menu />
  </div>
  );
};

export default EmpresaOffice;
